import { doAjax, initStitchesBackgroundColorListeners, initColorSelect, fakeSelected, changeStitchBackgroundColor } from './helper'
import { getColorByCode } from './color-languages'


const initLeatherCoverSelectLogic = () => {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	initColorSelect()
	loadBasicColorSeatLayers(frontSeatModel)

	let frontseatComponents = ['headrestSidePressedColor','headrestFrontPressedColor','shoulderArchPressedColor',
	'shoulderBolstersPressedColor','thighPadPressedColor','seatCenterPanelPressedColor','seatSideBolstersInsidePressedColor','circumferentialBandPressedColor','backrestTopPressedColor',
	'seatSideBolstersOutsidePressedColor','contrastStitchingSidePressedColor','contrastStitchingCenterPressedColor','contrastStitchingHoneycombQuiltingPressedColor',
	'contrastStitchingDiamondQuiltingPressedColor','embossingPressedColor','biesePressedColor','seatCoverPressedColor','contrastStitchingSeatCoverPressedColor',
	'backrestCoverPressedColor','seatCover2PressedColor']

	frontseatComponents.forEach(component => {
		initRedPointLogic('frontSeat', component)
		checkCustomizedComponentsOnLoading('frontSeat', component)
	});
}

const initRedPointLogic = (seatType, component) => {
	const componentMatchingDotId = getFrontSeatComponentDotId(component)
	const componentTiles = document.querySelectorAll('#' + componentMatchingDotId + ' .color')
	componentTiles?.forEach(element => {
		element.addEventListener("click", function (e) {
			e.preventDefault()
			const componentColorCode = element.querySelector('input')?.value
			const frontSeatComponentColorCode = document.querySelector('#seat-components #' + component + ' td[name=frontseat]')?.getAttribute('color-code')
			setImageOnSeat(seatType, component, componentColorCode)
		})
	})
}

function getFrontSeatComponentDotId(component) {
	switch (component) {
		case 'headrestSidePressedColor': return 'headrestSide'
		case 'headrestFrontPressedColor': return 'headrestFront'
		case 'shoulderArchPressedColor': return 'shoulderArch'
		case 'shoulderBolstersPressedColor': return 'shoulderBolsters'
		case 'thighPadPressedColor': return 'thighPad'
		case 'seatCenterPanelPressedColor': return 'seatCenterPanel'
		case 'seatSideBolstersInsidePressedColor': return 'seatSideBolstersInside'
		case 'circumferentialBandPressedColor': return 'circumferentialBand'
		case 'seatSideBolstersOutsidePressedColor': return 'seatSideBolstersOutside'
		case 'backrestTopPressedColor': return 'backrestTop'
		case 'contrastStitchingSidePressedColor': return 'contrastStitchingSide'
		case 'contrastStitchingCenterPressedColor': return 'contrastStitchingCenter'
		case 'contrastStitchingHoneycombQuiltingPressedColor': return 'contrastStitchingHoneycombQuilting'
		case 'contrastStitchingDiamondQuiltingPressedColor': return 'contrastStitchingDiamondQuilting'
		case 'embossingPressedColor': return 'embossing'
		case 'biesePressedColor': return 'biese'
		case 'seatCoverPressedColor': return 'seatCover'
		case 'contrastStitchingSeatCoverPressedColor': return 'contrastStitchingSeatCover'
		case 'backrestCoverPressedColor': return 'backrestCover'
		case 'seatCover2PressedColor': return 'seatCover2'
		default:
			break;
	}
}

function setStitchColorPrimSec(seatType, component, colorCode) {
	setImageOnSeat(seatType, component, colorCode)
	fakeSelected(getFrontSeatComponentDotId(component), colorCode)
}

function setImageOnSeat(seatType, component, colorCode) {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	// set leather color to stich 
	if(component == 'seatCoverPressedColor' 
		&& (document.querySelector('#seatCoverPressedColor td[color-code]').getAttribute('color-code') == document.querySelector('#contrastStitchingSeatCoverPressedColor td[color-code]').getAttribute('color-code')
			|| document.querySelector('#contrastStitchingSeatCoverPressedColor td[color-code]').getAttribute('color-code') == 99 )) {
		setStitchColorPrimSec(seatType, 'contrastStitchingSeatCoverPressedColor', colorCode)
	}
	replaceImage(seatType, component, colorCode, frontSeatModel)
	if (component != 'upholsteryBarOutside') {
		updateTableValue(seatType, component, colorCode)
	}
	const seatJson = createSeatJson(seatType, component, colorCode)
	doAjax(seatJson)
}


function replaceImage(seatType, component, colorCode, seatSelect) {
	const q1dembossing = document.querySelector("input[name=embossing]").value;
	
	if (document.getElementById(component)) {
		component = getFrontSeatComponentDotId(component)
		if (component == 'contrastStitchingSeatCover' || component == 'seatCover') {
			var imageSource = aeo['paths']['frontseat_'+seatSelect+'_YQN_component_path'][colorCode] + aeo['components']['seat_components_screen_default'][component] + '.png';
		} else {
			var imageSource = aeo['paths']['frontseat_'+seatSelect+'_component_path'][colorCode] + aeo['components']['seat_components_screen_default'][component] + '.png';
		}
		if(q1dembossing && component == 'backrestTop') {
			imageSource = aeo['images']['frontseat_'+seatSelect+q1dembossing+'_color'][colorCode]
		}
		let imageArray = document.getElementById('seat-single').querySelectorAll('.wrapper-relative img.overlay')
		const imageId = component + '-img'
		let imageExists = false;
		imageArray.forEach(element => {
			if (element.id != null && element.id == imageId) {
				imageExists = true
				element.src = imageSource
			}
		});
		if (!imageExists && imageArray.length > 0) {
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = component + '-img'
			imageArray[imageArray.length - 1].insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		}
	}
	
}

function updateTableValue(seatType, component, colorCode) {
	let query = '#seat-components #' + component + ' td[name=\"' + ('frontseat') + '\"]'
	let valueOnTable = document.querySelector(query)
	valueOnTable.setAttribute('color-code', colorCode)
	valueOnTable.innerHTML = getColorByCode(colorCode)
}


function createSeatJson(seatType, component, colorCode) {
	const json = {};
	json[seatType + 'Component'] = true
	json[component] = colorCode
	return json;
}


function loadBasicColorSeatLayers(seatSelect) {
	const seatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code').toString()
	const stitchSeatColorCode = document.querySelector('#picked-stitch td[color-code]')?.getAttribute('color-code').toString()
	const q1dembossing = document.querySelector("input[name=embossing]").value;
	const seatTypes = ["frontSeat"]
	seatTypes.forEach(seatType => {
		const seatColorSrc = aeo['images']['frontseat_'+seatSelect+'_color'][seatColorCode]
		const stitchColorSrc = aeo['images']['frontseat_'+seatSelect+'_stitch_color'][stitchSeatColorCode]
		const seatCoverColorSrc = aeo['images']['frontseat_'+seatSelect+'_seatcover_color'][seatColorCode]
		var embossingColorSrc = "/img/03_sitze/front_empty.png"
		if(q1dembossing && seatType == "frontSeat") {
			embossingColorSrc = aeo['images']['frontseat_'+seatSelect+q1dembossing+'_color'][seatColorCode]
		}
		const imgSources = [embossingColorSrc, seatCoverColorSrc, seatColorSrc, stitchColorSrc]
		imgSources.forEach(imageSource => {
			const query = '#' + ('seat-single') + ' img[alt="seat-base"]'
			let baseImage = document.querySelector(query)
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = seatType + 'basis-img'
			baseImage.insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		})
	})
}

/** Loads already customized components */
function checkCustomizedComponentsOnLoading(seatType, component) {
	const seatSelect = document.querySelector("input[name=frontseatmodel]").value; 
	const seatTypeNameValue = "frontseat"
	let query = `#seat-components #${component} td[name="${seatTypeNameValue}"]`
	let componentColorCode = document.querySelector(query)?.getAttribute('color-code')
	const mainSeatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code')
	if (componentColorCode != mainSeatColorCode) {
		replaceImage(seatType, component, componentColorCode, seatSelect)
	}
}

export { initLeatherCoverSelectLogic };